export default {
  data () {
    return {
      abilities: {
        OVERVIEW_VIEW:              BigInt(2**5),
        CAMPAIGNS_VIEW:             BigInt(2**6),
        CAMPAIGNS_CREATE:           BigInt(2**7),
        AUTOCONNECTS_VIEW:          BigInt(2**8),
        AUTOCONNECTS_EDIT:          BigInt(2**9),
        AUTOCONNECTS_CREATE:        BigInt(2**10),
        BUDZ_VIEW:                  BigInt(2**11),
        BUDZ_EDIT:                  BigInt(2**12),
        BUDZ_CREATE:                BigInt(2**13),
        CHECK_IN_VIEW:              BigInt(2**14),
        CHECK_IN_CREATE:            BigInt(2**15),
        CUSTOMER_LIST_VIEW:         BigInt(2**16),
        CUSTOMER_UPLOAD_VIEW:       BigInt(2**17),
        CUSTOMER_UPLOAD_CREATE:     BigInt(2**18),
        CUSTOMER_PROFILE_VIEW:      BigInt(2**19),
        CUSTOMER_PROFILE_EDIT:      BigInt(2**20),
        CUSTOMER_PROFILE_CREATE:    BigInt(2**21),
        REPORTS_VIEW:               BigInt(2**22),
        LOGS_VIEW:                  BigInt(2**23),
        SETTINGS_VIEW:              BigInt(2**24),
        SETTINGS_EDIT:              BigInt(2**25),
        SETTINGS_CREATE:            BigInt(2**26),
        MANAGE_USERS_EDIT:          BigInt(2**27),
        MANAGE_USERS_CREATE:        BigInt(2**28),
        FEEDBACK_VIEW:              BigInt(2**29),
        FEEDBACK_EDIT:              BigInt(2**30),
        FEEDBACK_CREATE:            BigInt(2**31),
        INSIGHTS_VIEW:              BigInt(2**32)
      },
      dependencies: {
        CHECK_IN_CREATE:            'CUSTOMER_PROFILE_CREATE',
        CUSTOMER_UPLOAD_VIEW:       'CUSTOMER_LIST_VIEW',
        CUSTOMER_UPLOAD_CREATE:     'CUSTOMER_LIST_VIEW',
        CUSTOMER_PROFILE_VIEW:      'CUSTOMER_LIST_VIEW',
        CUSTOMER_PROFILE_EDIT:      'CUSTOMER_LIST_VIEW',
        CUSTOMER_PROFILE_CREATE:    'CUSTOMER_LIST_VIEW',
        MANAGE_USERS_EDIT:          'SETTINGS_VIEW',
        MANAGE_USERS_CREATE:        'SETTINGS_VIEW'
      }
    }
    
  },

  methods: {
    hasAccess(userAbilitiesValue, abilitiesKey) {
      if (typeof userAbilitiesValue === 'number') { userAbilitiesValue = BigInt(userAbilitiesValue) }
      if (typeof userAbilitiesValue !== 'bigint') { return false }
      const abilityBit = this.getBit(abilitiesKey),
            allowed = abilityBit && ((userAbilitiesValue & abilityBit) > 0)

      return allowed
    },

    hasAccessToAutoCampaign(userAbilitiesValue, actionAbility, autoCampaign) {
      if (autoCampaign.type === 16)
        return this.hasAccess(userAbilitiesValue, `BUDZ_${actionAbility}`)
      else
        return this.hasAccess(userAbilitiesValue, `AUTOCONNECTS_${actionAbility}`)
    },
    
    getBit(abilitiesKey) {
      return this.abilities[abilitiesKey]
    },

    checkActionDependencies(id, isChecked) {
      const isCreate = id.includes('create'),
          isView = id.includes('view'),
          noDependencies = (isChecked && isView) || (!isChecked && isCreate)

      if (noDependencies) { return }
      this.setActionDependencies(id, isChecked, isCreate, isView)
    },

    checkPageDependencies(id) {
      const dependency = this.dependencies[id.toUpperCase()]
      
      if (!!dependency) {
        let bitValue = this.abilities[dependency]
        this.addToAbilitiesArray(bitValue)
        this.checkPageDependencies(dependency)
      }
    },

    setActionDependencies(id, isChecked, isCreate, isView) {
      const base = id.slice(0, isCreate ? -6 : -4)
      let actions = isChecked ? [`${base}view`] : [`${base}create`]

      if (isCreate || isView) { actions.push(`${base}edit`) }
      actions.forEach( (abilityKey) => {
        let bitValue = this.abilities[abilityKey.toUpperCase()],
            index = this.userAbilitiesArray.indexOf(bitValue)
        if (!bitValue) { return }
        if (isChecked) { 
          this.addToAbilitiesArray(bitValue)
        } else if (index > -1) {
          this.userAbilitiesArray.splice(index, 1)
        }
      })
    },

    sumAbilityValues() {
      const abilities = this.abilities
      let sum = 0n
      for(const page in abilities ) {
        sum += abilities[page]
      }
      return sum
    }
  },
}
